import { render, staticRenderFns } from "./IadeArizaOnayMailForEmployee.vue?vue&type=template&id=3a64df2b&"
import script from "./IadeArizaOnayMailForEmployee.vue?vue&type=script&lang=js&"
export * from "./IadeArizaOnayMailForEmployee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports